export default "__VITE_ASSET__yroBVFb$__"